var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThinArrow = function SvgThinArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 40.8 0 20.5 20.3.2l.7.7L1.3 20.5 21 40.1z"
  })));
};
export default SvgThinArrow;